import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_DATA_OBJECT} from '../../metamodel/Concept';

export default class DataObjectNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_DATA_OBJECT;
	}
}
